import { createReducer, createNamespacer } from '../commons/js/utils/reducer';
import { combineReducers } from "redux";

const initialState = {
    list: {
        isLoading: true,
        files: [],
        error: "",
        currentPage: 1,
        pageCount: 0,
    },
}

const namespacers = {
    listFiles: createNamespacer("FILES_LIST"),
}

const listReducer = createReducer(initialState.list, {
    [namespacers.listFiles("SET_FILES")]:(state, action) => {
        return {
            ...state,
            files: action.payload.value,
            pageCount: action.payload.pages,
        }
    },
    [namespacers.listFiles("SET_ERROR")]:(state, action) => {
        return {
            ...state,
            error: action.payload.value,
        }
    },
    [namespacers.listFiles("SET_PAGE")]: (state, action) => {
        return {
            ...state,
            currentPage: action.payload.value,
        }
    },
    [namespacers.listFiles("SET_LOADING")]:(state, action) => {
        return {
            ...state,
            isLoading: action.payload.value,
        }
    },
});

const reducer = combineReducers({
    list: listReducer,
})

export default reducer;
